module.exports = __webpack_public_path__ + "img/bsbank.bd28588d.png";